// Authentication Methods
export const AUTH_METHOD_EMAIL = 'email';
export const AUTH_METHOD_GOOGLE = 'google';
